import { css } from 'lit-element';
export const baseStyles = css `
  :host {
    box-sizing: border-box;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  slot {
    display: contents;
  }

  :host([hidden]) {
    display: none;
  }
`;
//# sourceMappingURL=styles.js.map